<template>
  <span v-if="modelValue.length" class="text-mid-dark-grey">
    {{ modelValue.length }} {{ label }}{{ modelValue.length > 1 ? 's' : '' }} selected
    <qtm-icon-btn color="mid-grey" density="compact" icon="mdi-close" @click="$emit('update:model-value', [])" />
  </span>
</template>

<script setup lang="ts">
export interface Props {
  label?: string
  modelValue: any[]
}

withDefaults(defineProps<Props>(), {
  label: 'item'
})

defineEmits(['update:model-value'])
</script>
